module.exports = __webpack_public_path__ + "img/logo-navbar.fa9077bc.svg";